// #region Imports
import { defineComponent } from "vue";
import { stringify } from "qs";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-catalog-category',
    // #endregion
    // #region Properties
    data: () => ({
        category: {},
        filter: [],
        pageSize: 3,
        recordCount: 0,
        isLoading: false,
        isMounted: false
    }),
    // #endregion
    // #region Constructor
    created() {
        this.loadCategory();
    },
    beforeMount() {
        this.isMounted = true;
        this.$host.eventBus.on('refresh', this.loadCategory);
    },
    beforeUnmount() {
        this.isMounted = false;
        this.$host.eventBus.off('refresh', this.loadCategory);
    },
    // #endregion
    // #region Computed
    computed: {
        hasFilter() {
            return this.filter && this.filter.length > 0 && !host.options.get('ecommerce_products_filterbar_hidden', this.category.options);
        },
        catalogID() {
            return this.$route.params.catalogID;
        },
        categoryID() {
            return this.$route.params.categoryID;
        },
        slugName() {
            return this.$route.params.slugName;
        },
        routeData() {
            return `${this.$route?.params?.categoryID}|${stringify(this.$route.query)}`;
        }
    },
    // #endregion
    // #region Watch
    watch: {
        "routeData"(value) {
            if (this.isMounted) {
                this.loadCategory();
            }
        },
    },
    // #endregion
    // #region Core
    methods: {
        async loadCategory() {
            // #region Check
            if (utils.isEmpty(this.categoryID) && utils.isEmpty(this.slugName)) {
                return;
            }
            // #endregion
            // #region Query
            //Catalog
            let tQuery = 'commerce/catalog';
            {
                if (this.slugName) {
                    tQuery += `/${this.slugName}`;
                }
                else if (this.catalogID) {
                    tQuery += `/${this.catalogID}`;
                }
                else {
                    return;
                }
            }
            //Category
            tQuery += '/category';
            {
                if (this.categoryID) {
                    tQuery += `/${this.categoryID}`;
                }
            }
            //Params
            let tParams = Object.assign({}, this.$route.query);
            // #endregion
            // #region Loading
            this.isLoading = true;
            // #endregion
            // #region Run
            try {
                //Run
                let tResult = await host.api.get(tQuery, { params: tParams });
                {
                    if (tResult.status === 204) {
                        //Redirect
                        this.$router.push('/');
                        //Result
                        this.isLoading = false;
                        return;
                    }
                    if (!tResult.data) {
                        this.isLoading = false;
                        return;
                    }
                }
                //breadcrumb  
                this.$store.commit('navigation/setBreadcrumb', tResult.data.breadcrumb);
                //Meta
                this.$host.pageMeta.setMeta({
                    title: tResult.data?.caption,
                    meta: tResult.data?.seo
                });
                //Data
                this.category = tResult.data;
                this.filter = tResult.data.filter;
                this.pageSize = tResult.data.pagination?.pageSize ?? 0;
                this.recordCount = tResult.data.pagination?.totalRecords ?? 0;
                //Internal
                this.isLoading = false;
            }
            catch (e) {
                this.isLoading = false;
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            }
            // #endregion
        },
    }
    // #endregion
});
// #endregion
